import { useQuery } from '@tanstack/react-query';

import { screenRulesQueryOptions } from '../../../../rules';

export type PasswordRules =
  | { readonly kind: 'ready'; readonly minLength: number }
  | { readonly kind: 'loading' }
  | { readonly kind: 'failed'; readonly retrying: boolean; readonly retry: () => void };

export const usePasswordRules = (): PasswordRules => {
  const rules = useQuery(screenRulesQueryOptions());
  if (rules.data !== undefined) return { kind: 'ready', minLength: rules.data.passwordMinLength };
  if (rules.isError) {
    return {
      kind: 'failed',
      retrying: rules.isFetching,
      retry: () => {
        void rules.refetch();
      },
    };
  }
  return { kind: 'loading' };
};
